import { useState } from "react";
import { Suggestions, Orphans } from "./Suggestions";
import { ExternalLinks, Backlinks } from "./External";

const VIEWS = [["suggest", "Internal link suggestions", Suggestions], ["orphans", "Orphan pages", Orphans], ["external", "External links", ExternalLinks], ["backlinks", "Backlinks", Backlinks]];

export default function LinkManager() {
  const [v, setV] = useState("suggest");
  const C = VIEWS.find((x) => x[0] === v)[2];
  return (
    <div className="space-y-4" data-testid="link-manager">
      <div><h2 className="text-lg font-extrabold text-steel">Link Manager</h2>
        <p className="text-sm text-muted-foreground">Connect products, categories, brands, services and articles with relevant links, find pages nothing links to, and keep outbound and inbound links healthy. Runs weekly automatically; nothing is published without your approval.</p></div>
      <div className="flex gap-1 border-b overflow-x-auto">
        {VIEWS.map(([k, l]) => <button key={k} onClick={() => setV(k)} data-testid={`lm-view-${k}`} className={`px-4 py-2 text-sm font-semibold border-b-2 -mb-px whitespace-nowrap ${v === k ? "border-accent text-steel" : "border-transparent text-muted-foreground"}`}>{l}</button>)}
      </div>
      <C />
    </div>
  );
}
